import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

export const visibleHiddenDesktopDownCssRaw = css.raw({
  smallDesktopDown: { visibility: 'hidden', position: 'absolute', zIndex: -1, touchAction: 'none' },
});

export const menuListCssRaw = css.raw({
  w: 'max-content',
  minW: 120,
  maxW: 210,
  '& > li + li': { mt: 4 },
});

export const menuItemCssRaw = stack.raw({
  textStyle: 'Text/M/Strong',
  textAlign: 'left',
  color: 'content.default.level-4',
  py: 8,
  gap: 4,
  _hover: { color: 'content.accent.info' },
});
